import gql from 'graphql-tag';
//agregar fecha de vigencia para apis
export const queryCliente = gql`
   query HistorialLicencia($ruc: String!) {
      historialLicencia(ruc: $ruc) {
         codigo
         iter
         documento
         producto
         usuario
         anio
         fechaExpiracion
         fechaVigenciaApi
         modular
         ide
         mac
         cpu
         placa
         bios
         sisoper
         ram
         chip
         fechaRegistroLicencia
         ultimaFechaMod
         ultimoUsuarioMod
         ultimaRazonMod
         fechaRegistro
      }
   }
`;
